var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerWages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-875.000000, -414.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(845.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions_PlayerWages",
    transform: "translate(30.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "transparent",
    mask: "url(#mask-2)",
    strokeWidth: 1.6,
    strokeDasharray: "0,0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    opacity: 0.65,
    transform: "translate(9.000000, 7.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24206329,8 C8.62533106,8 10.5634917,6.206 10.5634917,4 C10.5634917,1.794 8.62461083,0 6.24206329,0 C3.85951575,0 1.92063486,1.794 1.92063486,4 C1.92063486,6.206 3.85879551,8 6.24206329,8 Z M6.24206329,1.33333333 C7.83090847,1.33333333 9.12301557,2.52933333 9.12301557,4 C9.12301557,5.47066667 7.83090847,6.66666667 6.24206329,6.66666667 C4.6532181,6.66666667 3.361111,5.47066667 3.361111,4 C3.361111,2.52933333 4.6532181,1.33333333 6.24206329,1.33333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9506169,10.9786603 C11.5087258,10.3125134 9.09413274,8.83092385 6.722222,8.89064174 C4.35031126,8.95035964 2.88906163,9.74874128 1.65516044,11.0973865 C1.61034563,11.0554413 0.803678986,12.2192433 0.822351825,12.2270636 C0.298018509,13.1377724 0,14.1807152 0,15.2890642 C0,15.6815008 0.334617273,16 0.746913556,16 C1.15920984,16 1.49382711,15.6815008 1.49382711,15.2890642 C1.49382711,12.5448519 3.83913568,10.3125134 6.722222,10.3125134 C9.60530832,10.3125134 11.9506169,12.5448519 11.9506169,15.2890642 C11.9506169,15.6815008 12.2852342,16 12.6975304,16 C13.1098267,16 13.444444,15.6815005 13.444444,15.2890642 C13.444444,12.5051315 12.0563638,11.1380728 11.9506169,10.9786603 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerWages);
export default __webpack_public_path__ + "static/media/player-wages.07a2d7c71cf4d409f5a4ef7e4c04bd31.svg";
export { ForwardRef as ReactComponent };